import http from "./http"
const setting = {
  getSetting() {
    return http.get("setting/manage/list")
  },

  updateSetting(model) {
    return http.post("setting/manage/update", model)
  },

  getNotice() {
    return http.get("setting/getNotice")
  },
}
export default setting
